"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetch = fetch;

var ImmutableAPI = _interopRequireWildcard(require("crm_data/api/ImmutableAPI"));

var _q = _interopRequireDefault(require("q"));

var _Raven = _interopRequireDefault(require("Raven"));

var _immutable = require("immutable");

var API_URL = 'crm-record-cards/v1/record-cards';

function fetch(_ref) {
  var objectType = _ref.objectType;
  var earlyCardsLayoutRequest = window.quickFetch && window.quickFetch.getRequestStateByName("cardsLayout:" + objectType);

  if (earlyCardsLayoutRequest && !earlyCardsLayoutRequest.eventsRetrieved) {
    return new _q.default.Promise(function (resolve, reject) {
      earlyCardsLayoutRequest.whenFinished(function (response) {
        if (window.newrelic) {
          window.newrelic.setCustomAttribute('cardsLayoutRequest', 'succeeded');
        }

        earlyCardsLayoutRequest.eventsRetrieved = true;

        if (earlyCardsLayoutRequest) {
          window.quickFetch.removeEarlyRequest("cardsLayout:" + objectType);
        }

        resolve((0, _immutable.fromJS)(response));
      });
      earlyCardsLayoutRequest.onError(function (error) {
        _Raven.default.captureMessage('CardsAPI: Cards Layout early requester failed', {
          extras: {
            error: error
          }
        });

        if (window.newrelic) {
          window.newrelic.setCustomAttribute('cardsAPIEarlyRequest', 'failed');
        }

        earlyCardsLayoutRequest.eventsRetrieved = true;
        reject();
      });
    });
  }

  return ImmutableAPI.get(API_URL + "/" + objectType + "/for-object");
}